import {ISystemComponent, ResourcesPack} from '@gongxigames/framework/core/types';

export interface IModule extends ISystemComponent {
    getResourcesToLoad?(): ResourcesPack;
    restore(): void;
}
